"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("../api");
function blocksHeightGet(sdk, height) {
    return new api_1.TendermintRPCApi(undefined, sdk.url).blocksHeightGet(height);
}
exports.blocksHeightGet = blocksHeightGet;
function blocksLatestGet(sdk) {
    return new api_1.TendermintRPCApi(undefined, sdk.url).blocksLatestGet();
}
exports.blocksLatestGet = blocksLatestGet;
function syncingGet(sdk) {
    return new api_1.TendermintRPCApi(undefined, sdk.url).syncingGet();
}
exports.syncingGet = syncingGet;
function validatorsetsHeightGet(sdk, height) {
    return new api_1.TendermintRPCApi(undefined, sdk.url).validatorsetsHeightGet(height);
}
exports.validatorsetsHeightGet = validatorsetsHeightGet;
function validatorsetsLatestGet(sdk) {
    return new api_1.TendermintRPCApi(undefined, sdk.url).validatorsetsLatestGet();
}
exports.validatorsetsLatestGet = validatorsetsLatestGet;
